import * as React from "react";
import {
    Box, Container, CircularProgress, Alert, Stack, Divider, IconButton, Avatar, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import ButtonComponent from "components/Button";
import {
    schema,
} from "./helper";
import { getPrice, isMarketPlace, isAuthorized, getURI} from "helpers/utils";


import {useState, useEffect} from "react";
import {H2, H5, H6} from "components/CustomTypography";
import ImageAlbum from "components/elements/main/ImageAlbum";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopOffersSlider from "components/elements/user/offers/ShopOffersSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import UserProductRecommendedSelectedSlider from "components/elements/user/products/UserProductRecommendedSelectedSlider";
import ShopHeaderShopOverlay from "components/elements/user/shops/ShopHeaderShopOverlay";
import ShopHeaderOurCollection from "components/elements/user/shops/ShopHeaderOurCollection";
import MockProductImage from "components/elements/main/MockProductImage";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import TryOn from "components/icons/TryOn";
import Buy from "components/icons/Buy";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions/user/user-base.actions";
import {Notification} from "../../../../Atoms";

const UserProductDetailModal = ({
   selectedProduct, currency, onCancel, productdetail, isLoading, history, onAddToFavlistClicked,
   userMainGetShopInfoById, excludeHome, wholesale, userbootupInfo, generateVirtualTryOn, getTryOnProfileImage, 
   getTryOnCredits, getAllTryOnProfileImages
}) => {

    const [share, setShare] = useState(false);
    const [state, setState] = useState({});
    const [isGenerating, setIsGenerating] = useState(false);
    const [selectedProfileImageId, setSelectedProfileImageId] = useState(null);
    const [showProfileSelector, setShowProfileSelector] = useState(false);
    const [showRetryConfirmation, setShowRetryConfirmation] = useState(false);
    const [pendingTryOnData, setPendingTryOnData] = useState(null);

    let isModalSearch = false;

    let shopId = null;

    const {product, shops} = productdetail;

    const {
     created_at: createdAt, _id: _id, status, message
  } = selectedProduct || {};

  const [blur, setblur] = React.useState({
    status: false,
  });

  const { tryonProfileImage, virtualTryOnResult, tryonCredits, reqStatus, serviceError, tryonProfileImages } = userbootupInfo || {};

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };

  useEffect(() => {
      // Load all profile images on mount
      isAuthorized() && getAllTryOnProfileImages();
  }, []);

  useEffect(() => {
      // Set default selected image when profile images are loaded
      if (tryonProfileImages && tryonProfileImages.length > 0 && !selectedProfileImageId) {
          setSelectedProfileImageId(tryonProfileImages[0]._id);
      }
  }, [tryonProfileImages]);

  useEffect(() => {

      if (serviceError) {
          // Check if the error is about existing try-on (DUPLICATE_TRYON)
          const errorMessage = serviceError.statusText || serviceError.message || serviceError;
          
          if (typeof errorMessage === 'string' && errorMessage.includes('already created a virtual try-on')) {
              // Show confirmation dialog instead of error notification
              setShowRetryConfirmation(true);
              setIsGenerating(false);
              return;
          }
          
          // For other errors, show notification
          const feedback = {
              title: serviceError,
              description: serviceError.statusText,
          };
          sendNotification("error", feedback);
      }

    if (reqStatus === "GENERATE_VIRTUAL_TRYON_SUCCESS") {
      setIsGenerating(false);
        history.push(getURI(process.env.REACT_APP_TYPE, "mytryons", ""));
    } else if (reqStatus === "GENERATE_VIRTUAL_TRYON_FAILURE") {
      setIsGenerating(false);
        history.push(getURI(process.env.REACT_APP_TYPE, "mytryons", ""));
    }
  }, [reqStatus, serviceError]);

    const proceedWithTryOn = () => {
        // Store the try-on data in case we need to retry after confirmation
        setPendingTryOnData({
            productId: product.product_id,
            numberOfImages: 1,
            profileImageId: tryonProfileImages.length === 1 ? tryonProfileImages[0]._id : null
        });

        // If only one profile image, proceed directly
        if (tryonProfileImages.length === 1) {
            setIsGenerating(true);
            generateVirtualTryOn(product.product_id, tryonProfileImages[0]._id, 1);
            return;
        }

        // If multiple profile images, show selector
        setSelectedProfileImageId(tryonProfileImages[0]._id); // Set default selection
        setShowProfileSelector(true);
    };

    const handleTryOn = () => {
    if (!product || !product.product_id) {
      alert("Product information not available");
      return;
    }

    if (!tryonProfileImages || tryonProfileImages.length === 0) {
        history.push(getURI(process.env.REACT_APP_TYPE, "tryonprofile", ""));
        return;
    }

    //if (tryonCredits?.credits <= 0) {
    //    history.push(getURI(process.env.REACT_APP_TYPE, "mybag", ""))
    //    return;
    //}

    // Proceed with try-on - let the API check for existing try-ons
    proceedWithTryOn();
  };


  const handleConfirmRetry = () => {
    setShowRetryConfirmation(false);
    
    if (!pendingTryOnData) {
        return;
    }
    
    // User confirmed they want to try on again
    // Call the API with force_duplicate flag
    setIsGenerating(true);
    
    const profileImageId = pendingTryOnData.profileImageId || selectedProfileImageId;
    
    // Call generateVirtualTryOn with force_duplicate flag
    generateVirtualTryOn(
        pendingTryOnData.productId, 
        profileImageId, 
        pendingTryOnData.numberOfImages,
        true // force_duplicate = true
    );
    
    setPendingTryOnData(null);
  };

  const handleCancelRetry = () => {
      userbootupInfo.serviceError = "";
    setShowRetryConfirmation(false);
    setPendingTryOnData(null);
    setIsGenerating(false);
  };

  const handleConfirmTryOn = () => {
    if (!selectedProfileImageId) {
        return;
    }

    setShowProfileSelector(false);
    setIsGenerating(true);
    generateVirtualTryOn(product.product_id, selectedProfileImageId, 1);
  };

  const handleCancelProfileSelection = () => {
    setShowProfileSelector(false);
    setSelectedProfileImageId(null);
  };


    const onAddToFav = () => {
        onAddToFavlistClicked(product.id);
    };

  const hasError = () => {
    try {
      return !schema.validateSync(selectedProduct);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.status);

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, selectedProduct);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

    const handleTextFieldChange = (event, field) => {
        setState(event.target.value, field);
    };

    const handleVisitPage = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "tryonprofile", ""))
    };


    const handleBuyProduct = () => {
        shopId && history.push({pathname: `/shop/${shopId}/products/${product.id}`,
            state: {
                ws: wholesale
            },
        });
    };

    const renderProductInformation = () => (

        <Box>
            <H2 fontSize={18} sx={{ mb: "2", mt: "4", textTransform: "capitalize" }} textAlign="left" title={product.name} ellipsis>
                {product.name}
            </H2>
            <H5 fontSize={14} textAlign="left" ellipsis>
                {product.description}
            </H5>
        </Box>
    );

    const renderProductPhotos = () => (
        <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <ImageAlbum images={product.images}
                        onClickBottomRight={handleTryOn}
                        onClickBottomRightIcon={<TryOn />}
                        onClickTopRight={handleBuyProduct}
                        onClickTopRightIcon={<Buy />}
                        mainOnly={true} />
        </Box>
    );

    const renderProfileImageSelector = () => {
        if (!tryonProfileImages || tryonProfileImages.length <= 1) {
            return null;
        }

        return (
            <Dialog 
                open={showProfileSelector} 
                onClose={handleCancelProfileSelection}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Select Profile Image for Try-On
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ pt: 2 }}>
                        <Grid container spacing={2}>
                            {tryonProfileImages.map((profileImg) => (
                                <Grid item xs={4} sm={3} key={profileImg._id}>
                                    <Box
                                        onClick={() => setSelectedProfileImageId(profileImg._id)}
                                        sx={{
                                            cursor: 'pointer',
                                            position: 'relative',
                                            borderRadius: 1,
                                            overflow: 'hidden',
                                            border: selectedProfileImageId === profileImg._id ? '3px solid' : '2px solid',
                                            borderColor: selectedProfileImageId === profileImg._id ? 'primary.main' : 'grey.300',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                borderColor: 'primary.light',
                                                transform: 'scale(1.05)',
                                            }
                                        }}
                                    >
                                        <Avatar
                                            variant="square"
                                            src={profileImg.cdn?.secure_url}
                                            alt="Profile option"
                                            sx={{
                                                width: '100%',
                                                height: 'auto',
                                                aspectRatio: '3/4',
                                            }}
                                        />
                                        {selectedProfileImageId === profileImg._id && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 4,
                                                    right: 4,
                                                    bgcolor: 'primary.main',
                                                    borderRadius: '50%',
                                                    width: 28,
                                                    height: 28,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                ✓
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelProfileSelection} color="inherit">
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmTryOn} 
                        variant="contained" 
                        color="primary"
                        disabled={!selectedProfileImageId}
                    >
                        Try On with Selected Image
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    const renderRetryConfirmationDialog = () => {
        return (
            <Dialog
                open={showRetryConfirmation}
                onClose={handleCancelRetry}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Try On Again?
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        You've already created a virtual try-on for this product.
                    </Typography>
                    <Alert severity="info" sx={{ mt: 2 }}>
                        Creating a new try-on will use additional credits. Would you like to continue?
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelRetry} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmRetry}
                        variant="contained"
                        color="primary"
                    >
                        Yes, Try On Again
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    const renderProductBuyFromShop = () => (
        <Box>
            {shops.map((shop, index) => (
                <Box>
                    <ShopHeaderShopOverlay userMainGetShopInfoById={userMainGetShopInfoById} history={history} shopId={shop.id}/>
                </Box>
            ))}
        </Box>
    );


    const renderProductShopMoreInfo = () => (
        <Box>
            {shops.map((shop, index) => (
                <Box>
                    <Box onClick={() => history.push(`/shop/${shop.id}/products/${product.id}`)} alignContent="center" width="100%" display="flex" pt={1} pb={3}>
                        <Box width="70%">
                            <H2 textTransform="uppercase" fontSize={16} textAlign="left" ellipsis>
                                {shop?.title}
                            </H2>
                            <H6 textTransform="capitalize" fontSize={14} textAlign="left" title={product.area} ellipsis>
                                {shop?.area}
                            </H6>
                        </Box>
                        <Box width="30%" display="flex" alignItems="left">
                            <H2 fontSize={18}>
                                {getPrice(shop, currency)}
                            </H2>
                        </Box>
                    </Box>
                    <UserProductRecommendedSelectedSlider includeHeader={true} productId={product.id} />
                    <ShopProductPopularSlider includeHeader shopId={shop.id} />
                    <ShopProductNewSlider includeHeader shopId={shop.id} />
                    {/*<ShopOffersSlider shopId={shop.id} />*/}
                    {shopId = shop.id}
                </Box>
            ))}
        </Box>
    );


    const renderVirtualTryOn = () => {
        return (
            <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }} />
                <Stack spacing={2}>

                    {virtualTryOnResult && virtualTryOnResult.generated_images && virtualTryOnResult.generated_images.length > 0 && (
                        <Box>
                            <H5 fontSize={14} sx={{ mb: 2 }}>Try-On Result:</H5>
                            {virtualTryOnResult.generated_images.map((img, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <img
                                        src={img.cdn?.secure_url || img.url}
                                        alt={`Try-on result ${index + 1}`}
                                        style={{ width: '100%', borderRadius: '8px' }}
                                    />
                                </Box>
                            ))}
                        </Box>
                    )}
                </Stack>
            </Box>
        );
    };

    return (
        <Container>
            <Container maxWidth="md">



                {isLoading && <MockProductImage />}
                {!isLoading && renderProductPhotos()}
                {renderProfileImageSelector()}
                {renderRetryConfirmationDialog()}
                {!isLoading && renderProductShopMoreInfo()}
            </Container>
        </Container>
    );
};


// Mapping Props and State
const userProductDetailModal = connect(
    ({ userbootupInfo }) => ({
        reqStatus: userbootupInfo.reqStatus,
        isLoading: userbootupInfo.isLoading,
        serviceError: userbootupInfo.serviceError,
        tryonCredits: userbootupInfo.tryonCredits,
        tryonProfileImages: userbootupInfo.tryonProfileImages,
    }),
    (dispatch) =>
        bindActionCreators(
            {...Actions}, dispatch)
)(UserProductDetailModal);

export { userProductDetailModal as default };

